import classNames from 'classnames';
import styles from './TopWelcomeBlockSport.module.scss';
import Link from 'Components/shared/Link/Link';
import { EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import { PATHS } from '../../../../libraries/routes.library';
import { EBrandButtonTypes } from '../../../../libraries/buttons.library';
import DepositSelectSumManager from '../../../shared/DepositSelectSumManager/DepositSelectSumManager';
import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';
import { useEffect, useRef, useState } from 'react';
import { isServer } from '../../../../utils';
import TermsDisclaimer from '../../../blocks/TermsDisclaimer/TermsDisclaimer';
import BootstrapLoading from 'Components/shared/BootstrapLoading/BootstrapLoading';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import {
  EBaseButtonSize,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';
import { RegTypes } from 'Types/globals';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';

const { ClientJS } = isServer() ? { ClientJS: () => {} } : require('clientjs');
interface ITopWelcomeBlockSport {
  regtype: RegTypes;
  theme: {
    fallback_image: {
      url: string;
    };
    mobile: {
      mime: string;
      url: string;
    };
    desktop: {
      mime: string;
      url: string;
    };
    desktop_xl: {
      mime: string;
      url: string;
    };
    desktop_xxl: {
      mime: string;
      url: string;
    };
  };
  sport_landing: any;
}
const TopWelcomeBlockSport = ({ regtype, theme, sport_landing }: ITopWelcomeBlockSport) => {
  const contentContainerRef = useRef<HTMLDivElement>();
  const mainContainerRef = useRef<HTMLDivElement>();
  const [showBgImage, setShowBgImage] = useState(false);

  const showRegisterButton = useShowAuthButtons();

  useEffect(() => {
    if (contentContainerRef.current.offsetHeight <= mainContainerRef.current.offsetHeight / 1.56 - 18) {
      setShowBgImage(true);
    }
  }, [contentContainerRef?.current?.offsetHeight]);
  const { geo } = useSelector((state: IApplicationState) => state.globalReducer);

  const getTopOffset = () => {
    if (mainContainerRef && mainContainerRef?.current?.offsetWidth >= 834) return 'd-fl ai-c jc-c';

    if (regtype == RegTypes.PAYPLAY_T || regtype == RegTypes.PAYPLAY_Z) {
      return 'd-fl ai-fs jc-c';
    } else return 'd-fl ai-c jc-c';
  };

  const [themeConfig, SetThemeConfig] = useState({});

  const mobileVideoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    SetThemeConfig({
      '--mobile': `${
        theme.mobile.mime === 'image/webp'
          ? `url(${theme.mobile.url})`
          : theme.mobile.mime === 'video/mp4'
          ? ''
          : 'url(/images/homepage/header-tablet-mobile.jpg)'
      }`,
      '--desktop': `${
        theme.desktop.mime === 'image/webp'
          ? `url(${theme.desktop.url})`
          : theme.desktop.mime === 'video/mp4'
          ? ''
          : 'url(/images/homepage-c/d-header.jpg)'
      }`,
    });
    const client = new ClientJS();

    var isMobileIOS = client.isMobileIOS(); // Check For Mobile iOS]
    if (isMobileIOS) {
      mobileVideoRef?.current
        ?.play?.()
        .then(() => {})
        .catch(error => {
          //Do something like adding controls to allow user to manually play
          SetThemeConfig({
            ...themeConfig,
            '--mobile': `url(${theme?.fallback_image?.url})`,
          });
        });
    }
  }, []);

  const getDepositComponent = sport_landing => {
    switch (regtype) {
      case RegTypes.EMAIL:
        return (sport_landing?.button_title && showRegisterButton) ? (
          <div className={classNames(styles.cta_container, 'd-fl jc-c ai-c')}>
            <Link href={PATHS.REGISTER} className="w-100">
              <ButtonTextOnly
                label={sport_landing?.button_title}
                type={EBrandButtonTypes.Tertiary}
                size={EBaseButtonSize.Medium}
                textSize={EBaseTextSize.Large}
                fullWidth={true}
                textWeight={EBaseTextWeight.W600}
                alignText={EButtonTextAlign.Center}
                borderRadius={EButtonBorderRadiusStrength.Seven}
              />
            </Link>
          </div>
        ) : null;
      case RegTypes.PAYPLAY_T:
      case RegTypes.PAYPLAY_Z:
        return (
          <>
            <DepositSelectSumManager viewVersion="sport" />
            <div className={styles.terms_disclaimer_container}>
              <TermsDisclaimer />
            </div>
          </>
        );
    }
  };

  return (
    <>
      <BootstrapLoading isLoading={!sport_landing} />
      <div className={`${styles.top_welcome_block_c}`} ref={mainContainerRef}>
        <div
          className={classNames(styles.top_welcome_block_c_inner, {
            [styles.top_welcome_block_c_inner__fallback]: !theme?.mobile?.mime,
            [styles.top_welcome_block_c_inner__video]: theme?.mobile?.mime,
            [styles.top_welcome_block_c_inner__small]: !showBgImage,
          })}
          style={themeConfig as React.CSSProperties}
        >
          <div className={`${styles.content_container} ${getTopOffset()}`}>
            <div
              className={`${styles.content_container_inner} d-fl ai-c fd-c`}
              ref={contentContainerRef}
              style={{
                paddingTop: regtype == RegTypes.PAYPLAY_T || regtype == RegTypes.PAYPLAY_Z ? '45px' : '115px',
                marginBottom: regtype == RegTypes.PAYPLAY_T || regtype == RegTypes.PAYPLAY_Z ? '24px' : '115px',
              }}
            >
              <p className={`${styles.title}`}>
                <Trans components={{}} transKeepBasicHtmlNodesFor>
                  {sport_landing?.top_banner_title}
                </Trans>
              </p>
              <p className={`${styles.subtitle}`}>
                <Trans components={{}} transKeepBasicHtmlNodesFor>
                  {sport_landing?.top_banner_subtitle}
                </Trans>
              </p>
              <div className={`${styles.deposit_container}`}>{getDepositComponent(sport_landing)}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TopWelcomeBlockSport;
